export default "/images/save-and-new-icon.svg?3e36ffe890ababe12fc6cf9a3bcc18f4";